import React from "react";
import { defaultPageConfig, Page, PageConfig } from "/src/domain/shared/Page";
import { ChallengeStage } from "/src/domain/challenges/ChallengeStage";

import "../../i18n";

import { User, UserRole } from "/src/domain/shared/User";

import { mountComponentToContainer } from "/src/domain/shared/mountUtils";

import {
  ChallengeFormula,
  ChallengeProtocolData,
  DsqRecord,
  RecordType,
  SingleRaceRecord,
  TeamRaceRecord,
} from "/src/domain/challenges/ChallengeProtocolData";
import { ChallengeProtocolApp } from "/src/ui/challengeProtocol/ChallengeProtocolApp";

window.mountPage = mountPage;

function mountPage(
  page: Page,
  pageData: ChallengeProtocolData,
  currentUser?: User,
  pageConfig?: PageConfig
) {
  if (page !== Page.CHALLENGE_PROTOCOL) {
    console.error("Unknown page type");
    return;
  }

  mountComponentToContainer(
    page,
    pageData,
    currentUser,
    pageConfig || defaultPageConfig,
    ChallengeProtocolApp
  );
}

// const clubs = Array(3)
//   .fill(0)
//   .map((_, index) => `Club ${index + 1}`);

// mountPage(
//   Page.CHALLENGE_PROTOCOL,
//   {
//     challenge: {
//       name: "Солнцепёк - третий этап Кубка S10",
//       stage: ChallengeStage.BETA,
//       challengeKey: "YyI7gu314UuQ",
//       isProtocolVisible: true,
//       runWindow: {
//         startDate: "2021-07-17 14:29:17",
//         stopDate: "2021-07-17 16:27:02",
//       },
//       diplomas: [
//         "https://challenges.s10.run/diplom?e8af651ff7-1-ga1-4j6-zy45e",
//         "https://challenges.s10.run/diplom?e8af651ff7-1-ga1-4j6-zy45e",
//       ],
//       isDiplomaFree: false,
//       minTeamParticipants: 4,
//       maxTeamParticipants: 4,
//       formula: ChallengeFormula.BANANA,
//       startreg: 1,
//     },
//     protocols: [
//       {
//         title: "10 km",
//         records: Array(576)
//           .fill(0)
//           .map(
//             (_, index) =>
//               ({
//                 trackId: "5641560039" + index,
//                 place: index + 1,
//                 participant: {
//                   id: "10",
//                   isPremium: index % 2 == 0,
//                   city: "Санкт-Петербург",
//                   firstName: "Антон",
//                   lastName: `Петров ${index}`,
//                   coach: "Дежурный тренер",
//                   avatarUrl:
//                     index % 3 == 0 ? "https://i.pravatar.cc/150" : null,
//                   clubLogoUrl:
//                     index % 4 === 0
//                       ? `https://s10.run/i/team/${(index % 3) + 1}.png`
//                       : null,
//                   clubName: clubs[index % 5],
//                   team: index % 2 == 0 ? "Yandex" : "Mail",
//                 },
//                 time: 1905 + index,
//                 absolute: 1998 + index,
//                 comment: "GPS",
//                 parameters: [
//                   {
//                     index: 3,
//                     label: "startMsk",
//                     value: "10/18:25:58",
//                   },
//                   {
//                     index: 2,
//                     label: "finishMsk",
//                     value: "10/19:42:02",
//                   },
//                   {
//                     index: 1,
//                     label: "pace",
//                     value: 275,
//                   },
//                 ],
//                 type: RecordType.SINGLE_RACE,
//               } as SingleRaceRecord)
//           ),
//       },
//       {
//         title: "DSQ",
//         records: Array(6000)
//           .fill(0)
//           .map(
//             (_, index) =>
//               ({
//                 trackId: "5641560039" + index,
//                 comment: "Сбой Gps",
//                 participant: {
//                   id: "10",
//                   isPremium: true,
//                   city: "Санкт-Петербург",
//                   firstName: "Антон",
//                   lastName: `Петров ${index}`,
//                   coach: "Дежурный тренер",
//                   avatarUrl:
//                     "http://cs622426.vk.me/v622426834/409d/baLqspYwi84.jpg",
//                   clubLogoUrl: "https://s10.run/i/team/1.png",
//                   team: "Yandex",
//                 },
//                 time: 1905 + index,
//                 absolute: 1998 + index,
//                 parameters: [
//                   {
//                     index: 3,
//                     label: "startMsk",
//                     value: "10/18:25:58",
//                   },
//                   {
//                     index: 2,
//                     label: "finishMsk",
//                     value: "10/19:42:02",
//                   },
//                   {
//                     index: 1,
//                     label: "pace",
//                     value: 275,
//                   },
//                 ],
//                 type: RecordType.DSQ_RECORD,
//               } as DsqRecord)
//           ),
//       },
//     ],
//     pointTables: [],
//     upcomingRaces: [
//       {
//         name: "3+10 на двоих",
//         description: "Приглашайте новичков",
//         imgUrl:
//           "https://challenges.s10.run/i/index_banner/2021031514050146.jpg",
//         cardLink:
//           "https://challenges.s10.run/startgrp?utm_source=s10&utm_medium=indexbanner&utm_campaign=link",
//         distances: ["3 km", "10 km"],
//         dates: "20-21 марта",
//         links: [
//           {
//             url: "https:/asasda.asd",
//             label: "Registration",
//           },
//           {
//             url: "https:/asasda.asd",
//             label: "Registration",
//           },
//           {
//             url: "https:/asasda.asd",
//             label: "Registration",
//           },
//         ],
//       },
//       {
//         name: "3+10 на двоих",
//         description: "Приглашайте новичков",
//         imgUrl:
//           "https://challenges.s10.run/i/index_banner/2021031514050146.jpg",
//         cardLink:
//           "https://challenges.s10.run/startgrp?utm_source=s10&utm_medium=indexbanner&utm_campaign=link",
//         distances: ["3 km", "10 km"],
//         dates: "20-21 марта",
//         links: [],
//       },
//       {
//         name: "3+10 на двоих",
//         description: "Приглашайте новичков",
//         imgUrl:
//           "https://challenges.s10.run/i/index_banner/2021031514050146.jpg",
//         cardLink:
//           "https://challenges.s10.run/startgrp?utm_source=s10&utm_medium=indexbanner&utm_campaign=link",
//         distances: ["3 km", "10 km"],
//         dates: "20-21 марта",
//         links: [
//           {
//             url: "https:/asasda.asd",
//             label: "Registration",
//           },
//           {
//             url: "https:/asasda.asd",
//             label: "Registration",
//           },
//           {
//             url: "https:/asasda.asd",
//             label: "Registration",
//           },
//         ],
//       },
//       {
//         name: "3+10 на двоих",
//         description: "Приглашайте новичков",
//         imgUrl:
//           "https://challenges.s10.run/i/index_banner/2021031514050146.jpg",
//         cardLink:
//           "https://challenges.s10.run/startgrp?utm_source=s10&utm_medium=indexbanner&utm_campaign=link",
//         distances: ["3 km", "10 km"],
//         dates: "20-21 марта",
//         links: [],
//       },
//     ],
//     systemMessage: "",
//     ippodrom: [],
//     // ippodrom: [
//     //   {
//     //     capitanScore: 0,
//     //     ownScore: 99,
//     //     teamScore: 0,
//     //     totalScore: 99,
//     //     participant: {
//     //       id: "1",
//     //       isPremium: false,
//     //       city: "Санкт-Петербург",
//     //       firstName: "Антон",
//     //       lastName: "Питров",
//     //       coach: "Дежурный тренер",
//     //       specialCat: "Заезд на спортивных колясках",
//     //       clubLogoUrl: "https://s10.run/i/team/1.png",
//     //     },
//     //     place: 0,
//     //   },
//     //   {
//     //     capitanScore: 0,
//     //     ownScore: 66,
//     //     teamScore: 0,
//     //     totalScore: 66,
//     //     participant: {
//     //       id: "1",
//     //       isPremium: false,
//     //       city: "Санкт-Петербург",
//     //       firstName: "Антон",
//     //       lastName: "Питров",
//     //       coach: "Дежурный тренер",
//     //       specialCat: "Заезд на спортивных колясках",
//     //       clubLogoUrl: "https://s10.run/i/team/1.png",
//     //     },
//     //     place: 1,
//     //   },
//     // ],
//   },
//   {
//     id: "123",
//     currentTrainerId: "",
//     firstName: "",
//     isPremium: false,
//     lang: undefined,
//     lastName: "",
//     nowmsk: 0,
//     role: UserRole.STUDENT,
//     trainingsRequests: [],
//   }
// );
